import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import ElementInViewport from "../ElementInViewport.jsx";

const NewCommentsSplitter = ({ className, text, onEnterViewport }) => {
  return (
    <ElementInViewport
      onEnter={onEnterViewport}
      className={classnames(`new_comments_splitter`, className)}
    >
      <hr />
      <span className="new_comments_splitter_text">{text}</span>
      <hr />
    </ElementInViewport>
  );
};

NewCommentsSplitter.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  onEnterViewport: PropTypes.func,
};

NewCommentsSplitter.displayName = `NewCommentsSplitter`;

export default NewCommentsSplitter;
